
import Vue from 'vue'
import objectPath from 'object-path'

const mutations = {
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading
  },
  updateDocumentsLoading(state, payload) {
    state.documentsFormLoading = {
      ...state.documentsFormLoading,
      ...payload
    }
  },
  updateServiceField(state, { target, value }) {
    if (Array.isArray(value)) {
      objectPath.set(state, target, value)

      let formTarget = target.split('.')
      formTarget.pop()
      formTarget = formTarget.join('.')

      objectPath.set(state, formTarget, { ...objectPath.get(state, formTarget) })
    } else {
      objectPath.set(state, target, value)
    }
  },
  setFeedbackFields(state, payload) {
    state.feedback = {
      ...state.feedback,
      ...payload
    }
  },
  setFeedbackForm(state, payload) {
    state.feedback.form = {
      ...state.feedback.form,
      ...payload
    }
  },
  setOrder(state, payload) {
    const {
      orderId: id,
      tourists,
      dates,
      manager,
      bookings,
      vouchers,
      status,
      price,
      country,
      paymentHash
    } = payload

    state.id = id
    state.tourists = tourists
    state.dates = dates
    state.manager = manager
    state.bookings = bookings
    state.documents = vouchers
    state.status = status
    state.price = price
    state.country = country
    state.paymentHash = paymentHash
  },
  setBookingsIds(state, { bookings }) {
    const bookingsKeys = Object.keys(bookings)
    const result = []

    bookingsKeys
      .map(key => bookings[key])
      .forEach((service, i) => {
        service.forEach(serviceItem => result.push({
          id: serviceItem.bookingId,
          name: bookingsKeys[i]
        }))
      })

    state.bookingsIds = [...result]
  },
  setAllBookingsPenalties(state, { bookingId, penalties }) {
    state.allBookingsPenalties.push({
      bookingId,
      ...penalties
    })
  },
  setIsLoadingError(state, isError) {
    state.isLoadingError = isError
  },
  setInclude(state, include) {
    objectPath.set(state, 'include', include)
  },
  setMessages(state, { messages, userId }) {
    state.chat.messages = messages.map(message => ({
      ...message,
      isAuthor: message.author.id === userId
    }))

    if (state.chat.isOpened) {
      Vue.nextTick(() => {
        const chatArea = document.getElementById('orderChatArea')
        chatArea.scrollTop = chatArea.scrollHeight
      })
    }
  },
  addMessage(state, { message, userId }) {
    state.chat.messages.push({
      ...message,
      isAuthor: message.author.id === userId
    })

    if (state.chat.isOpened) {
      Vue.nextTick(() => {
        const chatArea = document.getElementById('orderChatArea')
        chatArea.scrollTop = chatArea.scrollHeight
      })
    }
  },
  setChat(state, payload) {
    state.chat = {
      ...state.chat,
      ...payload
    }

    if (state.chat.isOpened) {
      Vue.nextTick(() => {
        const chatArea = document.getElementById('orderChatArea')
        chatArea.scrollTop = chatArea.scrollHeight
      })
    }
  },
  setChatError(state, payload) {
    state.chatErrors = payload.map(({ source, title, detail }) => ({
      field: source,
      message: `${title}: ${detail}`
    }))
  }
}

export default mutations